/**
 * Shared styles for application dialogs.
 *
 * Styles are theme-driven so every dialog follows the active app theme.
 */
import { makeStyles } from '@material-ui/core/styles';

export const useDialogStyles = makeStyles(theme => ({
  title: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3, 2),
  },
  titleTextWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  titleText: { fontSize: '1.1rem', fontWeight: 700, lineHeight: 1.3 },
  titleSub: {
    fontSize: '0.82rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
  },
  closeBtn: {
    color: theme.palette.text.secondary,
    marginTop: -theme.spacing(0.5),
  },
  body: { padding: theme.spacing(1, 3, 2) },
  field: {
    marginBottom: theme.spacing(2.5),
    '&:last-child': { marginBottom: 0 },
  },
  label: {
    display: 'block',
    fontSize: '0.8rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  actions: { padding: theme.spacing(2, 3, 2.5), gap: theme.spacing(1) },
}));
